// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"27":"BuyerLazyComponent","46":"BadgeTooltipV1","795":"IntroVideoModal"}[chunkId] + "." + {"27":"540760b6b6a14cab8f62","46":"bcfa3871b07f9445876f","795":"fba989bff4e8c1244b84"}[chunkId] + ".js";
};